import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import CustomPrevArrow from "../Components/Carousel/CustomPrevArrow.jsx";
import CustomNextArrow from "../Components/Carousel/CustomNextArrow.jsx";

const Carousel = ({
    data,
    itemComponent,
    showSeller,
    displayDots,
    autoPlay,
    autoPlayInterval,
    speed,
    loop,
    pageSize,
    pageScroll,
    lazyLoad,
    showDetails,
    actionField,
    trackClicks,
    trackImpressions,
    restUrl
}) => {
    const Item = itemComponent;
    const settings = {
        dots: displayDots,
        autoplay: autoPlay,
        autoplaySpeed: autoPlayInterval,
        infinite: data.length > pageSize ? loop : false,
        speed: speed,
        slidesToShow: pageSize,
        slidesToScroll: pageScroll,
        lazyLoad: lazyLoad,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ],
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    return data.length > 0 ? (
        <Slider {...settings}>
            {data.map((record, index) => {
                return (
                    <div key={`carousel-item-${index}`}>
                        <Item
                            restUrl={restUrl}
                            show_seller={showSeller}
                            showDetails={showDetails}
                            trackClicks={trackClicks}
                            trackImpressions={trackImpressions}
                            actionField={actionField}
                            positionIndex={index + 1}
                            {...record}
                        />
                    </div>
                );
            })}
        </Slider>
    ) : null;
};

Carousel.defaultProps = {
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl"),
    lazyLoad: true,
    showDetails: true
};

Carousel.propTypes = {
    data: PropTypes.array.isRequired,
    itemComponent: PropTypes.func.isRequired,
    showSeller: PropTypes.bool,
    pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    loop: PropTypes.bool,
    displayDots: PropTypes.bool,
    speed: PropTypes.number,
    lazyLoad: PropTypes.bool,
    actionField: PropTypes.string,
    trackImpressions: PropTypes.bool,
    trackClicks: PropTypes.bool,
    restUrl: PropTypes.string,
    showDetails: PropTypes.bool
};

export default Carousel;